var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Backdrop, Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, ToggleButton, ToggleButtonGroup, useTheme } from '@mui/material';
import { ArrowRight01Icon } from 'hugeicons-react';
import { useEffect, useState } from 'react';
import { X } from 'react-feather';
import { useForm } from 'react-hook-form';
import { RoleCategories } from '../../../application/common/constants/role-categories';
import { useFindMachineMutation } from '../../../application/features/machines/machine-api';
import { useAppSelector } from '../../../application/store/useStore';
import useTranslate from '../../../localization/helpers';
import MachineDocuments from '../MachineDocuments';
import FindByMachine from './FindByMachine';
import FindBySerialNumber from './FindBySerialNumber';
var FindMachine = function (_a) {
    var isOpen = _a.isOpen, setIsOpen = _a.setIsOpen;
    var theme = useTheme();
    var translate = useTranslate().translate;
    var currentUser = useAppSelector(function (state) { return state.auth; }).currentUser;
    var _b = __read(useState(false), 2), machineDocumentsModalOpen = _b[0], setMachineDocumentsModalOpen = _b[1];
    var _c = __read(useState(false), 2), fileLoading = _c[0], setFileLoading = _c[1];
    var _d = __read(useState(false), 2), isMachinesBySerialNumberLoading = _d[0], setIsMachinesBySerialNumberLoading = _d[1];
    var _e = __read(useState('serialNumber'), 2), viewMode = _e[0], setViewMode = _e[1];
    var _f = __read(useFindMachineMutation(), 2), triggerGetMachine = _f[0], _g = _f[1], machine = _g.data, isMachineLoading = _g.isLoading, isSuccess = _g.isSuccess;
    var showMachineDocuments = machineDocumentsModalOpen && !isMachineLoading && !!machine;
    var isSuperAdmin = (currentUser === null || currentUser === void 0 ? void 0 : currentUser.roleCategory) === RoleCategories.SuperAdmin;
    useEffect(function () {
        if (isSuccess)
            setMachineDocumentsModalOpen(true);
    }, [isSuccess]);
    var _h = useForm({
        defaultValues: {
            serialNumber: '',
            modelNumber: '',
            id: ''
        }
    }), control = _h.control, handleSubmit = _h.handleSubmit, reset = _h.reset, setValue = _h.setValue, watch = _h.watch, errors = _h.formState.errors;
    var selectedMachine = watch('id');
    var onViewModeChanged = function (viewMode) {
        viewMode && setViewMode(viewMode);
        if (viewMode === 'serialNumber') {
            setValue('modelNumber', '');
        }
        setValue('id', '');
        setValue('serialNumber', '');
    };
    var onSubmit = function (query) { return triggerGetMachine(query); };
    var onClose = function () {
        reset();
        setIsOpen(false);
        setViewMode('serialNumber');
    };
    return (_jsxs(Dialog, { sx: { borderRadius: '44px' }, fullWidth: true, scroll: 'paper', open: isOpen, maxWidth: 'sm', children: [_jsx(Backdrop, { sx: { color: '#fff', zIndex: function (theme) { return theme.zIndex.drawer + 1; } }, open: fileLoading, children: _jsx(CircularProgress, { color: 'inherit' }) }), _jsxs(DialogTitle, { style: {
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    fontSize: '20px'
                }, children: [translate('assets.startAssetChat'), _jsx(IconButton, { color: 'inherit', style: { marginLeft: 'auto' }, onClick: onClose, children: _jsx(X, { size: 20, color: theme.palette.action.active }) })] }), _jsxs(DialogContent, { dividers: true, children: [_jsxs(ToggleButtonGroup, { sx: { my: { xs: 1.5, md: 3 }, maxHeight: 36, width: { xs: '100%', md: '100%' } }, value: viewMode, exclusive: true, onChange: function (_, value) { return onViewModeChanged(value); }, "aria-label": 'view mode', children: [_jsx(ToggleButton, { sx: {
                                    borderBottomLeftRadius: '8px !important',
                                    borderTopLeftRadius: '8px !important',
                                    flex: '1 1 auto',
                                    '&.Mui-selected': {
                                        backgroundColor: ' #009983 !important'
                                    }
                                }, value: 'serialNumber', children: translate('assets.image/SR') }), _jsx(ToggleButton, { sx: {
                                    borderBottomRightRadius: '8px !important',
                                    borderTopRightRadius: '8px !important',
                                    flex: '1 1 auto',
                                    '&.Mui-selected': {
                                        backgroundColor: ' #009983 !important'
                                    }
                                }, value: 'machine', children: translate('common.name') })] }), viewMode === 'serialNumber' ? (_jsx(FindBySerialNumber, { control: control, errors: errors, setValue: setValue, fileLoading: fileLoading, setFileLoading: setFileLoading, setIsMachinesLoading: setIsMachinesBySerialNumberLoading, isMachineLoading: isMachineLoading, onSubmit: handleSubmit(onSubmit), isSuperAdmin: isSuperAdmin })) : (_jsx(FindByMachine, { control: control, errors: errors, setValue: setValue, selectedMachine: selectedMachine }))] }), _jsxs(DialogActions, { children: [_jsx(Button, { onClick: onClose, variant: 'outlined', color: 'inherit', disabled: isMachineLoading, children: translate('actions.cancel') }), _jsx(Button, { onClick: handleSubmit(onSubmit), color: 'inherit', variant: 'contained', endIcon: _jsx(ArrowRight01Icon, {}), disabled: isMachineLoading || isMachinesBySerialNumberLoading, children: translate('assets.continue') })] }), showMachineDocuments && (_jsx(MachineDocuments, { machine: machine, isOpen: machineDocumentsModalOpen, setIsOpen: setMachineDocumentsModalOpen, onStartChat: function () { return onClose(); } }))] }));
};
export default FindMachine;
